import { call } from './apiHelpers';

export const auditService = {
  getAll: (filters) => call('get', 'audit/', null, filters),
};
